import { i18n, type Messages } from "@lingui/core";

export const locales = {
  en: "English",
  sl: "Slovenščina",
  // de: "Deutsch", // German disabled for now
} as const;

export type Locale = keyof typeof locales;

// Pre-defined catalog loaders for client-side (uses same .mjs files as SSR)
const catalogs: Record<Locale, () => Promise<{ messages: Messages }>> = {
  en: () => import("../../locales/en.mjs"),
  sl: () => import("../../locales/sl.mjs"),
  // de: () => import("../../locales/de.mjs"), // German disabled for now
};

// Dynamic catalog loading for client-side (uses same .mjs as SSR to avoid hydration mismatch)
export async function loadCatalog(locale: string): Promise<void> {
  const catalogLoader = catalogs[locale as Locale];
  if (!catalogLoader) {
    console.warn(`No catalog found for locale: ${locale}, falling back to en`);
    const { messages } = await catalogs.en();
    i18n.loadAndActivate({ locale: "en", messages });
    return;
  }
  const { messages } = await catalogLoader();
  i18n.loadAndActivate({ locale, messages });
}

// Synchronous catalog activation for SSR (messages already loaded)
export function activateCatalog(locale: string, messages: Messages): void {
  i18n.load(locale, messages);
  i18n.activate(locale);
}

export { i18n };
